import { useShopStatusStore } from "@/abilities/shop/features/shop-core/store/shop-status.store";
import { ShopCore } from "@/abilities/shop/types/shop-core";
import { ref } from "vue";
import { createShopApolloClient } from "../../shop-core/helper/create-shop-apollo-client";
import { useFdiAuth } from "./use-fdi-auth";

// Create singleton instances that persist across component lifecycles
const clientContainer = ref<ShopCore.ClientWithCache | undefined>(undefined);

export function useFdiClient() {
    const { getCurrentToken } = useFdiAuth();

    const getClient = async () => {
        const store = useShopStatusStore();
        const { baseUrl } = store.fdiShopConfig() ?? {};

        if (!baseUrl) {
            throw new Error("Base URL is not defined");
        }

        // Initialize client if needed
        if (!clientContainer.value) {
            const token = getCurrentToken();
            const accessToken = token?.accessToken;

            if (!accessToken) {
                throw new Error("Access token is not defined");
            }

            clientContainer.value = createShopApolloClient(baseUrl, {
                accessToken,
            });
        }

        return clientContainer.value.client;
    };

    const getHealthCheckClient = () => {
        const store = useShopStatusStore();
        const { baseUrl } = store.fdiShopConfig() ?? {};

        if (!baseUrl) {
            throw new Error("Base URL is not defined");
        }

        return createShopApolloClient(baseUrl, { healthCheckOnly: true }).client;
    };

    const resetClient = () => {
        clientContainer.value = undefined;
    };

    return {
        getClient,
        getHealthCheckClient,
        resetClient,
    };
}
